import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '@app/src/api/fetchHooks'
import type { SustainabilityTopic } from '@app/src/types/topicalRisk'
import { ONE_MINUTE_MS } from '@app/src/wf-constants'

interface UseProfileTopicsResult {
  topics: SustainabilityTopic[]
  isLoading: boolean
}

const TOPIC_INCLUDES = ['assessmentTemplate', 'assessmentTemplateSection']

export function useProfileTopics(): UseProfileTopicsResult {
  const { items = [], isLoading } = useFetchCollectionWithPost<SustainabilityTopic>({
    key: [FetchKey.SustainabilityTopics, 'profile'],
    endpoint: endpoints.sustainabilityTopics,
    payload: { filter: [], include: TOPIC_INCLUDES },
    options: { staleTime: ONE_MINUTE_MS * 60 },
  })

  return { topics: items, isLoading }
}
